import { useEffect, useRef, useState } from 'react';

export const useScrollOverflow = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  useEffect(() => {
    const element = scrollRef.current;
    if (!element) return;

    const onScroll = () => {
      setCanScrollLeft(element.scrollLeft > 0);
      setCanScrollRight(Math.ceil(element.scrollLeft) < element.scrollWidth - element.clientWidth);
    };

    onScroll();
    element.addEventListener('scroll', onScroll, { passive: true });

    const resizeObserver = new ResizeObserver(onScroll);
    resizeObserver.observe(element);

    return () => {
      element.removeEventListener('scroll', onScroll);
      resizeObserver.disconnect();
    };
  }, []);

  const scrollDataAttributes = {
    'data-can-scroll-left': canScrollLeft,
    'data-can-scroll-right': canScrollRight,
  };

  return { scrollRef, scrollDataAttributes };
};
